import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

interface IModalHeaderProps extends TestingProps {
  children?: React.ReactNode;
  close?: React.ReactNode;
  toggle?: () => void;
}

export const ModalHeader: React.FunctionComponent<IModalHeaderProps> = (
  props
) => {
  return (
    <div className="modal-header rc-p-4" data-testid={props.testId}>
      {props.children}
      {!!props.toggle &&
        (!!props.close ? (
          props.close
        ) : (
          <button
            type="button"
            className="close"
            aria-label="Close"
            onClick={props.toggle}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        ))}
    </div>
  );
};
